import React from "react";
import "./DocumentViewModal.css";

const STATUS_COLORS = {
  serga: "#ffcc00",
  atostogos: "#00aaff",
  na: "#ffaa00",
  laisva: "#00ff88",
  svente: "#bb66ff",
};

export default function DocumentViewModal({ item, status, onClose }) {
  if (!item) return null;

  const glow = STATUS_COLORS[status] || "#00ff88";

  return (
    <div className="dvm-backdrop">
      <div
        className="dvm-modal"
        style={{ boxShadow: `0 0 40px ${glow}` }}
      >
        <div className="dvm-header">
          <h2>Dokumento peržiūra</h2>
          <button className="dvm-close" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="dvm-content">
          <div className="dvm-row">
            <span>Darbuotojas</span>
            <strong>{item.name}</strong>
          </div>

          <div className="dvm-row">
            <span>Savaitė</span>
            <strong>{item.kw}</strong>
          </div>

          <div className="dvm-row">
            <span>Laikotarpis</span>
            <strong>{item.range}</strong>
          </div>
        </div>
      </div>
    </div>
  );
}
